import React, { useState } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { ContentContainer } from '../ContentContainer';
import Box from '@mui/material/Box';
import { DevicePropertiesDetails } from '../../types/device';
import deviceStyles from '../../app/device-management/DeviceStyle';
import { NavigationHeader } from '../NavigationHeader/NavigationHeader';
import { Grid, ListItemSecondaryAction } from '@mui/material';
import { LabelWithSubTitle } from '../LabelWithSubTitle/LabelWithSubtitle';
import { AppRoute } from '../../routes';
import ListItemIcon from '@mui/material/ListItemIcon';
import { StatusTag } from '../../components/StatusTag/StatusTag';
import { Status } from '../../types/site';
import { useSignalRSiteData } from '../../data/DataProviders/SignalRSiteDataProvider';
import _ from 'lodash';

export const PxChildDeviceProfileData: React.FC<{
    pxChildDeviceDetails: DevicePropertiesDetails | null;
    backAppRoute: AppRoute;
}> = (props) => {
    const classes = deviceStyles();
    const [pxChildDeviceInfo, setPxChildDeviceInfo] = useState<DevicePropertiesDetails | null>(null);
    const [deviceStatus, setDeviceStatus] = React.useState<boolean | null>();
    const realTimeSiteData = useSignalRSiteData();
    React.useEffect(() => {
        if (props.pxChildDeviceDetails) {
            setPxChildDeviceInfo(props.pxChildDeviceDetails);
        }
    }, [props.pxChildDeviceDetails]);

    React.useEffect(() => {
        if (pxChildDeviceInfo) {
            setDeviceStatus(pxChildDeviceInfo.status);
        }
    }, [pxChildDeviceInfo]);
    React.useEffect(() => {
        if (realTimeSiteData && realTimeSiteData.devices) {
            if (pxChildDeviceInfo) {
                const updatedDeviceStatus = _.find(realTimeSiteData.devices, {
                    deviceId: pxChildDeviceInfo.id,
                });
                if (updatedDeviceStatus) {
                    setDeviceStatus(updatedDeviceStatus.status);
                }
            }
        }
    }, [realTimeSiteData]);

    return (
        <>
            <ContentContainer>
                {pxChildDeviceInfo &&
                    (pxChildDeviceInfo.vendor === 'Eaton Corporation' || pxChildDeviceInfo.vendor === 'Eaton') && (
                        <>
                            <NavigationHeader
                                siteName={pxChildDeviceInfo.siteName}
                                for="device"
                                connectedDevice=""
                                device={pxChildDeviceInfo.name}
                            />
                            <Paper>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={6}>
                                        <Box>
                                            <List>
                                                <ListItem data-testid="child-device-name">
                                                    <Box width={400}>
                                                        <Typography
                                                            variant="h6"
                                                            color="primary"
                                                            style={{ wordWrap: 'break-word' }}
                                                        >
                                                            {pxChildDeviceInfo.name}
                                                        </Typography>
                                                    </Box>
                                                    <ListItemSecondaryAction>
                                                        <ListItemIcon
                                                            data-testid="device-status-icon"
                                                            style={{ display: 'block' }}
                                                        >
                                                            {deviceStatus ? (
                                                                <StatusTag
                                                                    status={Status.Online}
                                                                    style={{ marginRight: 30 }}
                                                                />
                                                            ) : (
                                                                <StatusTag
                                                                    status={Status.Offline}
                                                                    style={{ marginRight: 30 }}
                                                                />
                                                            )}
                                                        </ListItemIcon>
                                                    </ListItemSecondaryAction>
                                                </ListItem>
                                                <ListItem data-testid="device-type" className={classes.margin8}>
                                                    <LabelWithSubTitle
                                                        title={pxChildDeviceInfo.type}
                                                        subTitle={'Device'}
                                                    />
                                                </ListItem>

                                                <ListItem data-testid="vendor" className={classes.margin8}>
                                                    <LabelWithSubTitle
                                                        title={pxChildDeviceInfo.vendor}
                                                        subTitle={'vendor'}
                                                    />
                                                </ListItem>

                                                <ListItem data-testid="family" className={classes.margin8}>
                                                    <LabelWithSubTitle
                                                        title={pxChildDeviceInfo.family}
                                                        subTitle={'Family'}
                                                    />
                                                </ListItem>
                                            </List>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </>
                    )}
            </ContentContainer>
        </>
    );
};
